import { Box, Icon, Text } from '@rbilabs/universal-components';

import { primitive } from 'styles/constants';

export const Container = Box.withConfig({
  width: 'full',
  flexDirection: 'row',
  padding: '$3',
  background: primitive.$white,
  alignItems: 'center',
  justifyContent: 'center',
  borderBottomWidth: { base: 1, md: 0 },
  borderColor: primitive.$greyFour,
  marginX: { base: 0, md: '$3' },
});
export const DaypartHoursText = Text.withConfig({
  variant: 'copyOne',
});
export const SunriseIcon = Icon.withConfig({
  variant: 'bkSunrise',
  marginRight: '$2',
});
